import { from, Observable } from "rxjs";
import { map, mergeMap, toArray } from "rxjs/operators";

/**
 * Runs `project` for every input with at most `concurrency` inner observables
 * subscribed at the same time. The result preserves the input order and is
 * `[]` for an empty input. Errors are propagated as in `forkJoin`.
 */
export function mapWithConcurrency<T, R>(
  inputs: readonly T[],
  project: (input: T) => Observable<R>,
  concurrency: number
): Observable<R[]> {
  return from(inputs.map((input: T, index: number) => ({ input, index }))).pipe(
    mergeMap(
      ({ input, index }) =>
        project(input).pipe(map((result: R) => ({ result, index }))),
      concurrency
    ),
    toArray(),
    map((results) =>
      results
        .sort((left, right) => left.index - right.index)
        .map((x) => x.result)
    )
  );
}
